import { ANALYZE_FOR_ENTRY_COMPONENTS, ModuleWithProviders, NgModule, Provider, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { CookieService } from 'ngx-cookie-service';

import { AuthRoutingModule } from './auth-routing.module';
import { PAGES } from './pages';
import { AUTH_GUARDS } from './guards';
import { AUTH_SERVICES } from './services';
import { AUTH_PROVIDERS, AuthProvider, STORAGE } from './providers';

import { AUTH_CONFIG, AuthConfig } from '~auth/providers/auth.provider';


export function provideAuth(p: Type<AuthProvider>) {
  return {
    provide: AUTH_PROVIDERS,
    useClass: p,
    multi: true
  };
}


const USER_MODALS = [];

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    AuthRoutingModule,
    HttpClientModule
  ],
  declarations: [...PAGES],
  exports: [...PAGES]
})
export class AuthModule {
  static forRoot(providers: Provider[] = [], config: AuthConfig): ModuleWithProviders {
    return {
      ngModule: AuthModule,
      providers: [
        ...AUTH_SERVICES,
        ...AUTH_GUARDS,
        CookieService,
        ...providers,
        { provide: HTTP_INTERCEPTORS, useClass: config && config.interceptor, multi: true },
        { provide: ANALYZE_FOR_ENTRY_COMPONENTS, useValue: USER_MODALS, multi: true },
        { provide: STORAGE, useValue: localStorage },
        { provide: AUTH_CONFIG, useValue: config }
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts